import HttpError from "../../common/models/HttpError";
import MylemonadeScopes from "../../common/models/MyLemonadeScopes";

export default class TaxError {
    static TAX_NOT_FOUND: HttpError = new HttpError("TAX_NOT_FOUND", "Tax can't be found", 500, MylemonadeScopes.TAXES);
    static INVALID_TAX_RATE: HttpError = new HttpError("INVALID_TAX_RATE", "Tax rate is invalid", 500, MylemonadeScopes.TAXES);
}